import { vistaListarGastoXMetodo } from "../infrastructure/supabase/gastosVistaMetodo.repository.js";

import { mapGastoMetodo } from "../application/mappers/gastoMetodo.mapper.js";


export async function listarGastoXMetodoUseCase(filtros = {}) {

  const {
    fechaInicio = null,
    fechaFin = null,
    metodoPago = null,
    categoria = null,
    clasificacion = null
  } = filtros;

  const filtrosNormalizados = {
    fechaInicio,
    fechaFin,
    metodoPago,
    categoria,
    clasificacion
  };

  return vistaListarGastoXMetodo(filtrosNormalizados);
}

export async function listarGastoXMetodoMapUseCase(filtros = {}) {

  const {
    fechaInicio = null,
    fechaFin = null,
    metodoPago = null,
    categoria = null,
    clasificacion = null
  } = filtros;

  const filtrosNormalizados = {
    fechaInicio,
    fechaFin,
    metodoPago,
    categoria,
    clasificacion
  };

  const data = await vistaListarGastoXMetodo(filtrosNormalizados);

  return (data || []).map(mapGastoMetodo);
}